var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 110.94,
    cy: 108.5,
    rx: 46.46,
    ry: 87.73,
    transform: "translate(-38.46 66.57) rotate(-28.69)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 110.94,
    cy: 108.5,
    rx: 87.73,
    ry: 48.4,
    transform: "translate(-39.83 145.22) rotate(-58.05)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 110.94,
    cy: 108.5,
    rx: 87.73,
    ry: 48.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.85,
    cy: 107.85,
    r: 21.93
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtom);
export default __webpack_public_path__ + "static/media/ATOM.121a13cf04478a1b09a64fdf2e602bcd.svg";
export { ForwardRef as ReactComponent };